//colors
export const blue = `rgb(0,118,190)`;
export const darkBlue = `#01558A`;
export const red = `#cc0000`;
